export default "__VITE_ASSET__DwqcF8Pz__"